import React from 'react';

const Contact = () => {
  return (
    <>
      <style>{`
@font-face {
  font-family: 'CustomFont';
  src: url('/Orbitron/Orbitron-VariableFont_wght.ttf') format('woff2'),
       url('/Orbitron/Orbitron-VariableFont_wght.ttf') format('woff');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'CustomFont', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #000;
  color: #fff;
}

header {
  background-color: #000;
  color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
  position: relative;
}

.buy-coffee {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #f5c65d;
  text-decoration: none;
  line-height: 1.1;
  font-size: 0.93rem;
  text-align: center;
  font-family: 'CustomFont', sans-serif;
}

nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

nav a {
  color: #fff;
  text-decoration: none;
}

nav a:active {
  color: #fdca05;
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}

.social-links a {
  color: #fdca05;
  text-decoration: none;
}

.header-logo {
  width: 250px;
  height: auto;
}

footer {
  background-color: #000;
  color: #fff;
  text-align: center;
  padding: 0px 0;
  position: fixed;
  font-size: 0.73rem;
  bottom: 0;
  width: 100%;
}

@media screen and (max-width:600px){
  nav {
    flex-wrap: wrap;
    gap: 10px;
  }
}
      `}</style>

      <main>
        <section style={{ textAlign: 'center', padding: '2rem' }}>
          <p style={{ fontSize: '1.1rem', lineHeight: 1.4 }}>
            For more information, email{' '}
            <a
              href="mailto:info@streetflavorrecords.com"
              style={{ color: '#fdca05', textDecoration: 'underline' }}
            >
              info@streetflavorrecords.com
            </a>
          </p>
        </section>
      </main>

      <footer>
        <p>&copy; 2025 Street Flavor Records / SPNDAT INC. All rights reserved.</p>
      </footer>
    </>
  );
};

export default Contact;
